import store from '../store/index';

export function getAgent() {
    let isMobile = false;
    if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPad|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        isMobile = true;
    } else {
        isMobile = false;
    }
    store.commit('setIsMobile', isMobile);
}

// 后续可能会域名更换，避免生产环境域名更换出现问题。
export function isPro() {
    const HOST = window.location.host;
    const HOST_UAT = 'hsrc-uat.test.honor.com';
    const HOST_DEV = 'localhost.honor.com:8080';
    return !(HOST === HOST_UAT || HOST === HOST_DEV);
}



// WEBPACK FOOTER //
// ./src/utils/utils.js